import React, { useState } from 'react';
import {
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Dropdown,
  Button,
} from '@axiom/ui';
import type { Account } from '@axiom/validation';

import { ClientAccountPickerModalSchema } from './client-account-picker-modal-schema';

export interface ClientAccountPickerModalProps {
  accounts: Account[];
  onClose: () => void;
  onContinue: (account: Account) => void;
}

export const ClientAccountPickerModal = ({
  accounts,
  onClose,
  onContinue,
}: ClientAccountPickerModalProps) => {
  const [selectedAccount, setSelectedAccount] = useState<Account>();

  const accountOptions = accounts.map(account => ({
    id: account.id,
    calculatedName: account.calculatedName || account.name,
    account,
  }));

  const handleOnSubmit = () => {
    if (selectedAccount) {
      onContinue(selectedAccount);
    }
  };

  return (
    <Form
      name="CLIENT_ACCOUNT_PICKER_FORM"
      schema={ClientAccountPickerModalSchema}
      initialValues={{
        accountId: '',
      }}
      onSubmit={handleOnSubmit}
    >
      {({ fireSubmit }) => {
        return (
          <Modal name="CLIENT_ACCOUNT_PICKER_MODAL" size="confirm">
            <ModalHeader
              name="CLIENT_ACCOUNT_PICKER_MODAL_HEADER"
              onClose={() => {
                onClose();
              }}
            >
              Choose account
            </ModalHeader>
            <ModalSection disableScrolling>
              <Dropdown
                label="Account"
                description="Choose the account you would like to interview for."
                name="accountId"
                options={accountOptions}
                displayKey="calculatedName"
                valueKey="id"
                onChange={(_accountId, _e, option) => {
                  const foundOption = option as (typeof accountOptions)[number];
                  setSelectedAccount(foundOption.account);
                }}
              />
            </ModalSection>
            <ModalFooter>
              <Button
                name="CLIENT_ACCOUNT_PICKER_CANCEL_BUTTON"
                variation="outline"
                type="button"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button
                name="CLIENT_ACCOUNT_PICKER_NEXT_BUTTON"
                type="submit"
                onClick={fireSubmit}
              >
                Next
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};
